export default {
  state: {
    onEventPanel: '',
    showAddBar: window.localStorage.getItem('little-star-hotkey-showAddBar') || '⇧+⌘+a, ⇧+⌃+a',
    showEdit: window.localStorage.getItem('little-star-hotkey-showEdit') || '⇧+⌘+Space, ⇧+⌃+Space',
    searchStar: window.localStorage.getItem('little-star-hotkey-searchStar') || '⇧+⌘+s, ⇧+⌃+s',
    searchTag: window.localStorage.getItem('little-star-hotkey-searchTag') || '⇧+⌘+l, ⇧+⌃+l',
  },
  mutations: {
    setOnEventPanel(state, name) {
      state.onEventPanel = name
    },
    setHotKeyVal(state, { key, value }) {
      state[key] = value
    },
    initHotkey(state, data) {
      if (data) {
        for (const key in data) {
          state[key] = data[key]
          window.localStorage.setItem(`little-star-hotkey-${key}`, data[key])
        }
      }
    },
  },
  actions: {
    setHotKey({ commit }, { key, value }) {
      return this._vm.$http.put('/user/hotkeys', {
        type: 'web',
        key,
        value,
      }).then(() => {
        window.localStorage.setItem(`little-star-hotkey-${key}`, value)
        commit('setHotKeyVal', { key, value })
      })
    },
  },
  namespaced: true,
}
